export const statusColors = {
  new: 'text-success-500',
  holdover: 'text-yellow-600',
  expiring: 'text-error-500',
  recalled: 'text-purple-500',
}

export const statusTypes = {
  new: 'success',
  holdover: 'warning',
  expiring: 'error',
  recalled: 'info',
  unknown: 'default',
}
